export function getIbanValidationEndpoint(): string {
    return '/iban/validate';
}
